// `delete.extension.tpl.html` — "Delete search alert?", the screen an email's unsubscribe link
// opens.
//
// ⚠️ THE BUTTON IS INERT UPSTREAM, AND THAT IS UPSTREAM'S OWN STATE. `DeleteExtensionAlertController.deleteAlert`
// is an empty method with a `// deprecated` comment in it, so the live screen shows a Delete
// button that does nothing and never reaches `ctrl.success`. Wiring it here would be a new
// feature written into a port — the fix, if it is one, belongs upstream first (CLAUDE.md).
// `onDelete` exists so that fix has somewhere to land, and nothing calls it.
//
// ⚠️ AND THE STATE BLOCKS ARE `ng-show`, NOT `ng-if` — they are in the DOM, hidden. Rendering
// them conditionally is the same pixels (`.ng-hide` is `display: none`) and the same visible
// text, which is what the capture measures; a port that reproduced `ng-hide` classes would be
// reproducing AngularJS rather than the screen.
import type { ReactElement } from 'react'

export interface DeleteAlertPageProps {
  /** `ctrl.success` — replaces the CTA half with "Alert deleted." */
  success?: boolean
  /** `ctrl.error` — "Something went wrong." */
  error?: boolean
  onDelete?: () => void
}

export function DeleteAlertPage({ success = false, error = false, onDelete }: DeleteAlertPageProps): ReactElement {
  return (
    <div className="delete-extension-alert-container">
      <div className="delete-extension-cta">
        <h3>Delete search alert?</h3>
        {success || error ? null : (
          <div>
            <br />
            <button
              type="submit"
              className="btn btn-danger"
              onClick={() => {
                onDelete?.()
              }}
            >
              Delete
            </button>
          </div>
        )}
      </div>
      <br />
      <div className="delete-extension-cta">
        {success ? <h3>Alert deleted.</h3> : null}
        {error ? <h3>Something went wrong.</h3> : null}
      </div>
    </div>
  )
}
